var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"featureButtons"},_vm._l((_vm.features),function(item){return _c('div',{key:item.key,class:[`featureButtons__feature featureButtons__feature--${item.key}`, item.selected && 'selected']},[_c('span',[_vm._v(_vm._s(item.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }